import {
  configureWithRelationshipSerializer,
  configureVersionedSerializer,
  configurePaginatedSerializer,
} from './utils';

const BookWithRelationshipsSerializer = configureWithRelationshipSerializer({
  includeForeignModelAttrs: {
    modifiedBy: ['name'],
    publishedBy: ['name'],
    createdBy: ['name'],
  },
});

const BookWithVersionSerializer = configureVersionedSerializer({ baseSerializer: BookWithRelationshipsSerializer });

const PaginatedBookSerializer = configurePaginatedSerializer({ baseSerializer: BookWithVersionSerializer });

export default {
  book: BookWithVersionSerializer,
  paginatedBooks: PaginatedBookSerializer,
};
